/**
 * Decision Constants (Canonical Enums)
 * Authority: UI Design Spec v1.0 §5.3 (Rejection Categories)
 *
 * Defines immutable decision types, rejection reason codes (for supervised
 * learning), and defer durations for all Inbox workflows.
 */

export const DECISION_TYPES = {
    ACCEPT: 'ACCEPT',
    REJECT: 'REJECT',
    DEFER: 'DEFER',
};

// ============================================================
// REJECTION REASON CODES — Predefined for ML training data
// Spec §5.3: "structured for supervised learning. No free text."
// ============================================================
export const REASON_CODES = {
    NOT_RELEVANT: 'NOT_RELEVANT',
    LOW_QUALITY: 'LOW_QUALITY',
    DUPLICATE: 'DUPLICATE',
    TIMING: 'TIMING',
    NEEDS_RESEARCH: 'NEEDS_RESEARCH',
    DISAGREE_WITH_AGENT: 'DISAGREE_WITH_AGENT',
    OTHER: 'OTHER',
};

export const REASON_LABELS = {
    [REASON_CODES.NOT_RELEVANT]: 'Not relevant to fund thesis',
    [REASON_CODES.LOW_QUALITY]: 'Low quality / poorly written',
    [REASON_CODES.DUPLICATE]: 'Already covered / duplicate',
    [REASON_CODES.TIMING]: 'Timing not right',
    [REASON_CODES.NEEDS_RESEARCH]: 'Needs more research first',
    [REASON_CODES.DISAGREE_WITH_AGENT]: 'Agent assessment disagrees with my judgment',
    [REASON_CODES.OTHER]: 'Other',
};

// ============================================================
// DEFER DURATIONS — Spec §5.2
// ============================================================
export const DEFER_DURATIONS = [
    { label: 'Snooze 1 Day', value: '1d' }, // noscan
    { label: 'Snooze 1 Week', value: '1w' }, // noscan
    { label: 'Snooze 1 Month', value: '1m' }, // noscan
];

// ============================================================
// SOURCE MAP — Maps work_type to human-readable source names
// Spec §5.1: "Which agent/automation generated this"
// ============================================================
// ============================================================
// DURATION MAP — Frontend → Backend Translation
// ============================================================
export const DURATION_MAP = {
    '1d': '1_day',
    '1w': '1_week',
    '1m': '1_month',
};

// ============================================================
// DEFER LABELS — Display Text for Defer Durations
// ============================================================
export const DEFER_LABELS = {
    '1d': '1 day',
    '1w': '1 week',
    '1m': '1 month',
};

export const SOURCE_MAP = {
    campaign: { label: 'Email Outreach', group: 'automation' }, // noscan
    kb: { label: 'Article Agent', group: 'agent' }, // noscan
    review_generic: { label: 'Article Agent', group: 'agent' }, // noscan
    article_review: { label: 'Article Agent', group: 'agent' }, // noscan
    startup: { label: 'Deal Sourcing', group: 'agent' }, // noscan
    code_fix: { label: 'System', group: 'system' },
    deployment: { label: 'System', group: 'system' },
    lead_gen_scout: { label: 'LinkedIn Scout', group: 'agent' }, // noscan
};
